<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="search-outline"></nb-icon>
        <div class="ml-2" i18n>Viewing Campaign: {{ campaign.id }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <div class="row">
      <!-- left -->
      <div class="col-12 col-lg-6">
        <dl class="row small">
          <dt class="col-4" i18n>Name</dt>
          <dd *ngIf="!campaignNameValidator" class="col-10">{{ campaign.name }}</dd>
          <dd *ngIf="campaignNameValidator" class="col-10 error" i18n>{{ campaign.name }} (invalid campaign name)</dd>
          <dt class="col-4" i18n>Description</dt>
          <dd class="col-10">{{ campaign.description || 'n/a' }}</dd>
          <dt class="col-4" i18n>Campaign App Type</dt>
          <dd class="col-10">{{ campaign.app_type | titlecase }}</dd>
          <ng-container *ngIf="campaign.category !== null">
            <dt class="col-4" i18n>Category</dt>
            <dd class="col-10">{{ campaign.category | titlecase }}</dd>
          </ng-container>
          <ng-container *ngIf="payloadRecordTypes?.length">
            <dt class="col-4" i18n>Content Payload Type</dt>
            <dd class="col-10">
              <span *ngFor="let payloadRecordType of payloadRecordTypes; let last = last">
                {{ payloadRecordType.replace('_', ' ') | titlecase }}<span *ngIf="!last">, </span>
              </span>
            </dd>
          </ng-container>
          <dt class="col-4" i18n>Campaign Type</dt>
          <dd class="col-10">{{campaign.campaign_type}}</dd>
        </dl>
      </div>
      <!-- right  -->
      <div class="col-12 col-lg-6">
        <dl class="row small">
          <ng-container>
            <dt class="col-4" i18n>Status</dt>
            <dd class="col-10">
              {{ statusLabel }}
            </dd>
          </ng-container>
          <ng-container *ngIf="campaign.start_date !== null && campaign.end_date !== null">
            <dt class="col-4" i18n>Schedule</dt>
            <dd class="col-10">{{ formattedStartTime }} - {{ formattedEndTime }}</dd>
          </ng-container>
          <ng-container *ngIf="campaign.schedule_seconds !== null">
            <dt class="col-4" i18n>Frequency</dt>
            <dd class="col-10">{{ scheduleLabel }}</dd>
          </ng-container>
          <ng-container *ngIf="campaign.frequency_days !== null">
            <dt
              class="col-4"
              i18n
              i18n-nbTooltip
              nbTooltip="The amount of time that must elapse before the user can receive the message again after first receiving it."
            >
              Resend Buffer
            </dt>
            <dd class="col-10" i18n>{{ campaign.frequency_days }} days</dd>
          </ng-container>
          <ng-template #noUserRight>
            <dd class="col-10" i18n>Unknown</dd>
          </ng-template>
        </dl>
      </div>
    </div>

    <hr />

    <div class="row">
      <!-- left -->
      <div class="col-12 col-lg-6">
        <ng-container *ngIf="!campaign.is_real_time">
          <dl class="row small">
            <dt class="col-4" i18n>Insight/Trigger ID</dt>
            <dd class="col-10 d-flex align-items-center gap-4 mt-2">
              {{ campaign.trigger_id }}
              <button
                nbButton
                class="ml-3 pt-1"
                size="tiny"
                status="info"
                [routerLink]="[]"
                (click)="viewInsight(campaign.trigger_id)"
                i18n
              >
                View
              </button>
            </dd>
          </dl>
        </ng-container>
        <dl class="row small" *ngIf="campaign.content_id !== null">
          <dt class="col-4" i18n>Content ID</dt>
          <dd class="col-10 d-flex align-items-center mt-2">
            {{ campaign.content_id }}
            <button
              nbButton
              size="tiny"
              status="info"
              class="ml-3 pt-1"
              [routerLink]="[]"
              (click)="viewContent(campaign.content_id)"
              i18n
            >
              View
            </button>
          </dd>
        </dl>
        <dl class="row small">
          <dt class="col-4" i18n>Surveys</dt>
          <dd class="col-10">
            <ng-container *ngIf="selectedSurveys?.length; else noSurveys">
              <div *ngFor="let survey of selectedSurveys" class="d-flex align-items-center mt-2">
                {{ survey.name }}
                <button
                  nbButton
                  size="tiny"
                  status="info"
                  class="ml-3 pt-1"
                  [routerLink]="[]"
                  (click)="viewSurvey(survey)"
                  i18n
                >
                  View
                </button>
              </div>
            </ng-container>
            <ng-template #noSurveys>
              <span i18n>There are no Surveys associated with this campaign</span>
            </ng-template>
          </dd>
        </dl>
      </div>
      <!-- right -->
      <div class="col-12 col-lg-6">
        <ng-container *ngIf="show_condition; else noConditions">
          <dl class="row small">
            <dt class="col-2" i18n>Condition</dt>
            <dd class="col-10"></dd>
            <ng-container *ngIf="condition_all?.length">
              <dd class="col-2" i18n>ALL:</dd>
              <dd class="col-10"></dd>
              <dd class="col-12 ps-0">
                <div *ngFor="let campaign of condition_all" class="d-flex align-items-center mt-2">
                  {{ campaign.campaign_id }}
                  <button
                    nbButton
                    size="tiny"
                    status="info"
                    class="ml-3"
                    [routerLink]="[]"
                    (click)="viewCampaign(campaign.campaign_id)"
                    i18n
                  >
                    View
                  </button>
                </div>
              </dd>
            </ng-container>
            <ng-container *ngIf="condition_any?.length">
              <dd class="col-2" i18n>ANY:</dd>
              <dd class="col-10"></dd>
              <dd class="col-12 ps-0">
                <div *ngFor="let campaign of condition_any" class="d-flex align-items-center mt-2">
                  {{ campaign.campaign_id }}
                  <button
                    nbButton
                    size="tiny"
                    status="info"
                    class="ml-3"
                    [routerLink]="[]"
                    (click)="viewCampaign(campaign.campaign_id)"
                    i18n
                  >
                    View
                  </button>
                </div>
              </dd>
            </ng-container>
            <ng-container *ngIf="condition_not_all?.length">
              <dd class="col-2" i18n>NOT ALL:</dd>
              <dd class="col-10"></dd>
              <dd class="col-12 ps-0">
                <div *ngFor="let campaign of condition_not_all" class="d-flex align-items-center mt-2">
                  {{ campaign.campaign_id }}
                  <button
                    nbButton
                    size="tiny"
                    status="info"
                    class="ml-3"
                    [routerLink]="[]"
                    (click)="viewCampaign(campaign.campaign_id)"
                    i18n
                  >
                    View
                  </button>
                </div>
              </dd>
            </ng-container>
            <ng-container *ngIf="condition_not_any?.length">
              <dd class="col-2" i18n>NOT ANY:</dd>
              <dd class="col-10"></dd>
              <dd class="col-12 ps-0">
                <div *ngFor="let campaign of condition_not_any" class="d-flex align-items-center mt-2">
                  {{ campaign.campaign_id }}
                  <button
                    nbButton
                    size="tiny"
                    status="info"
                    class="ml-3"
                    [routerLink]="[]"
                    (click)="viewCampaign(campaign.campaign_id)"
                    i18n
                  >
                    View
                  </button>
                </div>
              </dd>
            </ng-container>

            <dt class="col-3" *ngIf="show_condition" i18n>Time Frame</dt>
            <dd class="col-10"></dd>
            <dd class="col-9" *ngIf="show_condition" i18n>{{ time_frame }} days</dd>
          </dl>
        </ng-container>
        <ng-template #noConditions>
          <dl class="row small">
            <dt class="col-2" i18n>Condition</dt>
            <dd class="col-10"></dd>
            <dd class="col-12" i18n>There are no Conditions associated with this campaign</dd>
          </dl>
        </ng-template>
      </div>
    </div>

    <hr />

    <div class="row">
      <!-- left -->
      <div class="col-12 col-lg-6">
        <dl class="row small">
          <ng-container *ngIf="campaign.last_run_time">
            <dt class="col-4" i18n>Last Run Time</dt>
            <dd class="col-10">{{ formattedLastRunTime }}</dd>
          </ng-container>
          <dt *ngIf="campaign?.status" class="col-4" i18n>Last Run Status</dt>
          <dd *ngIf="campaign?.status" class="col-10">{{ campaign.status | titlecase }}</dd>
          <ng-container *ngIf="campaign.next_run_time !== null">
            <dt class="col-4" i18n>Next Run Time</dt>
            <dd class="col-10">{{ formattedNextRunTime }}</dd>
          </ng-container>
          <ng-container *ngIf="campaign.executions">
            <dt class="col-4" i18n>Total Executions</dt>
            <dd class="col-10">{{ campaign.executions }}</dd>
          </ng-container>
          <ng-container *ngIf="campaign.executions && campaign.total_duration">
            <dt class="col-4" i18n>Average Execution Time</dt>
            <dd class="col-10">{{ averageExecDuration }}</dd>
          </ng-container>
          <dt class="col-4" i18n>Total Deliveries</dt>
          <dd class="col-10">{{ totalDeliveries }}</dd>
        </dl>
      </div>

      <!-- right -->
      <div class="col-12 col-lg-6">
        <dl class="row small">
          <dt class="col-4" i18n>Created By</dt>
          <dd class="col-10" *ngIf="campaign.created_by !== null; else noUserLeft">
            {{ campaign.created_by }}
          </dd>
          <ng-template #noUserLeft>
            <dd class="col-10" i18n>Unknown</dd>
          </ng-template>
          <dt class="col-4" i18n>Created On</dt>
          <dd class="col-10">{{ formattedCreatedTime }}</dd>
          <dt class="col-4" i18n>Last Updated By</dt>
          <dd *ngIf="campaign.last_updated_by !== null; else noUserRight" class="col-10">
            {{ campaign.last_updated_by }}
          </dd>
          <dt class="col-4" i18n>Last Updated On</dt>
          <dd class="col-10">{{ formattedUpdatedDate }}</dd>
          <dt *ngIf="campaign.promoted" class="col-4" i18n>Promoted</dt>
          <dd *ngIf="campaign.promoted" class="col-10" i18n>True</dd>
          <dt *ngIf="showPromoterUsername" class="col-4" i18n>Promoted by</dt>
          <dd *ngIf="showPromoterUsername" class="col-10">{{ campaign.promoted_by }}</dd>
        </dl>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button *ngIf="displayManagementButtons" nbButton class="ml-3" status="success" (click)="runOnce(campaign)" i18n>
        Run Once
      </button>
      <button
        *ngIf="displayPromotionButton"
        nbButton
        [disabled]="!disablePromotionButton"
        class="ml-3"
        status="success"
        (click)="promoteCampaign()"
        i18n
      >
        Promote
      </button>
      <button
        *ngIf="displayManagementButtons"
        nbButton
        class="ml-3"
        status="info"
        (click)="viewStats(campaign.id)"
        i18n
      >
        View Stats
      </button>
      <button
        *ngIf="displayManagementButtons && campaign.enabled === true"
        nbButton
        class="ml-3"
        status="danger"
        (click)="deactivateCampaign()"
        i18n
      >
        Deactivate
      </button>
      <button *ngIf="displayManagementButtons && campaign.enabled === false" nbButton class="ml-3" status="success" (click)="activateCampaign()" i18n>
        Activate
      </button>
    </div>
  </nb-card-footer>
</nb-card>
